/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import Swal from "sweetalert2";
import { LOGIN_API_UPDATED, LOGIN_DOMAIN, TOKEN_INVALIDATE_URL } from "../Api/APIURLS";
import { CommonAjaxPostLoginRequestUpdated, CommonAjaxTokenInvalidate } from "../Api/CommonAjaxUtils";
import { ClearLocalStorage } from "../components/Functions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

var createGuest = require('cross-domain-storage/guest');

const LogOut = () => {
    const dispatch = useDispatch();
    const history = useHistory()
    let mainAppGuest = createGuest(LOGIN_DOMAIN);

    useEffect(() => {
        // CommonAjaxTokenInvalidate(TOKEN_INVALIDATE_URL, dispatch)

        let refresh_token = JSON.parse(localStorage.getItem('refresh_token'))
        // console.log("useEffect ... ", refresh_token);
        let params = {
            "refreshToken": refresh_token,
            "clientId": "nidhi"
        }
        if (refresh_token) {
            CommonAjaxPostLoginRequestUpdated(LOGIN_API_UPDATED + 'auth/logout', params).then((res) => {
                if (res) {
                    if (res?.status === 200) {
                        ClearLocalStorage(mainAppGuest);
                        dispatch({ type: 'RESET_STATE' });
                        Swal.fire({
                            text: res?.data?.message,
                            icon: 'success',
                            confirmButtonText: 'Ok',
                            customClass: {
                                confirmButton: "swal-button--confirm"
                            }
                        }).then(function (isConfirm) {
                            if (isConfirm.value) {
                                history.replace("/login");
                            }
                        });
                    }
                }
            })
        }
        else {
            Swal.fire({
                text: 'You are already logged out or your session has expired.',
                icon: 'info',
                confirmButtonText: 'Ok',
                customClass: {
                    confirmButton: "swal-button--confirm"
                }
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    history.replace("/login");
                }
            });
        }
        // CommonAjaxTokenInvalidate(LOGIN_API_UPDATED + 'auth/logout', dispatch)
        //     .then(res => {
        //         if (res !== '' && res !== undefined && res !== null) {
        //             ClearLocalStorage(mainAppGuest);
        //             dispatch({ type: 'RESET_STATE' });

        //             Swal.fire({
        //                 text: 'You have Successfully Logged Out',
        //                 icon: 'success',
        //                 confirmButtonText: 'Ok',
        //                 customClass: {
        //                     confirmButton: "swal-button--confirm"
        //                 }
        //             }).then(function (isConfirm) {
        //                 if (isConfirm.value) {
        //                     history.replace("/login");
        //                 }
        //             });
        //         } else {
        //             Swal.fire({
        //                 text: 'You are already logged out or your session has expired.',
        //                 icon: 'info',
        //                 confirmButtonText: 'Ok',
        //                 customClass: {
        //                     confirmButton: "swal-button--confirm"
        //                 }
        //             }).then(function (isConfirm) {
        //                 if (isConfirm.value) {
        //                     history.replace("/login");
        //                 }
        //             });
        //         }
        //     })
        //     .catch(error => {
        //         console.error("Logout failed:", error);
        //         Swal.fire({
        //             text: 'An error occurred during logout. Please try again.',
        //             icon: 'error',
        //             confirmButtonText: 'Ok',
        //             customClass: {
        //                 confirmButton: "swal-button--confirm"
        //             }
        //         })
        //         // .then(() => {
        //         //     history.replace("/login");
        //         // });
        //     });
    }, []);

    return null;
};

export default LogOut;